import { Controller } from "@hotwired/stimulus";

// Automatic order acceptance confirms an order on its
// own; auto-dispatch is what asks for a courier. With
// the first on and the second off, an order confirms
// itself and then sits waiting for a "Mark as ready"
// tap the merchant has no reason to expect. That is
// how Restaurante ZaRo's order 369 stranded a customer
// for two hours (CAL-471).
//
// The server already draws the notice in its correct
// state, so this only keeps it honest while the two
// checkboxes move. The host element is the order-type
// card: the two inputs sit in different sections of it,
// and a Stimulus target resolves only among its
// controller element's descendants.
export default class extends Controller {
  static targets = ["acceptance", "dispatch", "notice"];

  connect() {
    this.update();
  }

  update() {
    if (!this.hasNoticeTarget) return;

    const accepting = this.hasAcceptanceTarget && this.acceptanceTarget.checked;

    // A withheld toggle renders no input at all, and
    // that IS auto-dispatch off: the warning belongs
    // there more than anywhere.
    const dispatching = this.hasDispatchTarget && this.dispatchTarget.checked;

    this.noticeTarget.classList.toggle("hidden", !(accepting && !dispatching));
  }
}
